module.exports = __webpack_public_path__ + "media/music/c36dd943607003a3229aca77b49d32de.mp3";